import React, { useEffect, useState } from 'react';
import qs from 'qs';
// import _ from 'lodash';
import { withRouter } from 'react-router';
// import CryptoJS, { AES } from 'crypto-js';

// import { encryptionSecret } from './Secret';

import { AppProps, LTIData } from './App.interfaces';

import './App.css';

function App(props: AppProps) {
  const [data, setData] = useState<LTIData | null>(null);

  useEffect(() => {
    try {
      const search = props.location.search;
      const query = qs.parse(search, { ignoreQueryPrefix: true }) as { q?: string };

      if (!query.q) return;

      const encryptedQuery = decodeURIComponent(query.q);

      // const bytes = AES.decrypt(encryptedQuery, encryptionSecret);
      // const queryDecode = bytes.toString(CryptoJS.enc.Utf8);
      // const queryObject = JSON.parse(queryDecode);

      /**
       * TODO ICHSAN
       * use base64 just for temporary
       */
      const decrypted = atob(encryptedQuery);
      const parsed = JSON.parse(decrypted) as LTIData;

      setData(parsed);
    } catch (error) {
      if (error instanceof Error) {
        console.log(error.message);
      }
    }
  }, [props.location.search]);

  useEffect(() => {
    if (!data) return;

    const parameter: { [key: string]: any } = {
      
    };

    for (let i = 0; i < data.parameter.length; i += 1) {
      const item = data.parameter[i];

      parameter[item.key] = item.value;
    }

    const form = document.querySelector<HTMLFormElement>("#ltiForm");

    if (!form) return;

    for (const name in parameter) {
      const node = document.createElement("input");
      node.name = name;
      node.type = "hidden";
      node.value = parameter[name];
      form.appendChild(node);
    }

    form.submit();
  }, [data]);

  if (!data?.url) {
    return (
      <div
        style={{
          width: "100%",
          height: "80vh",
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          fontSize: 14,
        }}
      >
        Content being opened...
      </div>
    )
  }

  return (
    <form className="d-none" action={data?.url} method="POST" id="ltiForm" />
  );
}

export default withRouter(App);
